import { render, staticRenderFns } from "./cat-sub-grade-drpdn.vue?vue&type=template&id=350bc69c&scoped=true&"
import script from "./cat-sub-grade-drpdn.ts?vue&type=script&lang=ts&"
export * from "./cat-sub-grade-drpdn.ts?vue&type=script&lang=ts&"
import style0 from "./cat-sub-grade-drpdn.scss?vue&type=style&index=0&id=350bc69c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350bc69c",
  null
  
)

export default component.exports